<section
  *ngIf="numberOfWinners$ | async as numberOfWinners; else spinner"
  class="content-layout"
  [brightsideWebFb]="{ event_name: 'contest_details' }"
>
  <bw-action-article-legacy>
    <ui-nav-exit-back
      back-action-top
      [trackingDetail]="{ event_name: 'contest_details' }"
      (exitActionHandler)="backToSavingsDashboard()"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <img src="../assets/rewards_pig.svg" alt="contest-details" class="mb-md" />
          <typography-legacy text-large-regular color="var(--secondary-text)" class="mb-sm">
            {{ 'CONTEST_DETAILS_TITLE' | translate }}
          </typography-legacy>
          <p title-medium class="mb-sm" *ngIf="numberOfWinners">
            {{ 'CONTEST_DETAILS_DESC' | translate : { numberOfWinners } }}
          </p>
          <div class="contest-details__container">
            <div class="contest-details__item">
              <div>
                <typography-legacy text-small class="contest-details__item-detail-title">
                  {{ 'CONTEST_DETAILS_ITEM1_TITLE' | translate }}
                </typography-legacy>
                <typography-legacy text-small class="contest-details__item-detail" color="var(--secondary-text)">
                  {{ 'CONTEST_DETAILS_ITEM1_DESC' | translate }}
                </typography-legacy>
              </div>
            </div>

            <div class="contest-details__item">
              <div>
                <typography-legacy text-small class="contest-details__item-detail-title">
                  {{ 'CONTEST_DETAILS_ITEM2_TITLE' | translate }}
                </typography-legacy>
                <typography-legacy text-small class="contest-details__item-detail" color="var(--secondary-text)">
                  {{ 'CONTEST_DETAILS_ITEM2_DESC' | translate }}
                </typography-legacy>
              </div>
            </div>

            <div class="contest-details__item">
              <div>
                <typography-legacy text-small class="contest-details__item-detail-title">
                  {{ 'CONTEST_DETAILS_ITEM3_TITLE' | translate }}
                </typography-legacy>
                <typography-legacy text-small class="contest-details__item-detail" color="var(--secondary-text)">
                  {{ 'CONTEST_DETAILS_ITEM3_DESC' | translate }}
                </typography-legacy>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div footer-actions>
      <button bw-link-button-legacy [secondaryCta]="true" [brightsideWebFb]="{ event_name: 'contest_details' }" (click)="showRules()">
        <span [innerHTML]="'CONTEST_DETAILS_RULES' | translate"></span>
      </button>
    </div>
  </bw-action-article-legacy>
</section>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
